export default "__VITE_ASSET__DxtEcxDW__"